//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ColoredStoneButtonGroup',
  props: {
    control: {required: true},
    data: {required: true},
    product: {required: true},
    stonePositions: {required: true},
  },
  data() {
    return {
      selectedColorStones: [],
      selectedStoneValues: [],
      oldStoneGroupList: this.StoneGroupList,
    }
  },
  computed: {
    itemIsEngravable() {
      return this.product.IsEngravable
    },
    engravingEnabled() {
      return this.data.ENGRAVABLE.Value == 1
    },
    coloredStoneType() {
      return this.product.ColoredStoneType
    },
    coloredStoneTypeName() {
      return this.coloredStoneType == 'GEN' ? 'genuine' : 'synthetic'
    },
    apiRootUrl() {
      return this.$config.axios.browserBaseURL.replace('api/', '')
    },
    field() {
      return this.product.Controls.filter((c) => c.type == this.control.type)[0]
    },
    currentStoneNumber() {
      return this.product.FormData.STNB.Value
    },
    StoneGroupList() {
      const stoneGroupList = []
      for (const group in this.reorderStoneTypes(this.control.GroupedOptions.slice(
        0,
        this.currentStoneNumber
      ))) {
        const lStoneList = []
        const currentGroup = this.reorderStoneTypes(this.control.GroupedOptions)[group]
        let groupedOptions =  currentGroup.GroupedOptions.find(
            (x) => x.Key === this.coloredStoneType
        )
        let visibleOptions = []
        if (groupedOptions){
          visibleOptions =  this.getVisibleOptions(
              groupedOptions.Options,
              currentGroup.Key
          )
        }

        for (const item in visibleOptions) {
          const isSelected =
            this.product.FormData.CS[currentGroup.Value].Value ===
            visibleOptions[item].value
          lStoneList.push({
            ID: visibleOptions[item].value,
            Month: visibleOptions[item].text,
            Name: visibleOptions[item].text2,
            ImageUrl: this.getImageSource(
              visibleOptions[item].value,
              currentGroup.Code
            ),
            Value: visibleOptions[item].value,
            GroupValue: currentGroup.Value,
            selectedStone: isSelected,
            shape: currentGroup.Name.split(' ')[0],
            class: visibleOptions[item].Class,
          })
        }
        if (
          this.product.FormData.CS[currentGroup.Value] &&
          this.product.FormData.CS[currentGroup.Value].Value &&
          !visibleOptions.some(
            (x) =>
              x.value === this.product.FormData.CS[currentGroup.Value].Value
          )
        ) {
          let optionValue = this.product.FormData.CS[currentGroup.Value].Value
          let index = optionValue.indexOf('&')
          let newOptionString = optionValue.slice(0, index)

          let newOption = lStoneList.find(x => x.Value.includes(newOptionString))

          if (newOption) {
            this.selectedColorStones[currentGroup.Key - 1] = newOption
            this.selectedStoneValues[currentGroup.Key - 1] = newOption.ID

            this.$emit('updateValue', {
              controlType: this.control.type,
              controlName: this.control.name,
              controlSubName: currentGroup.Value,
              value: newOption.Value,
              summary: this.getSummary(newOption),
            })
          }
          else{
            // Reset selected stone if not found under newly selected colored stone type
            this.product.FormData.CS[currentGroup.Value].Value = null
            if (this.selectedColorStones[currentGroup.Key - 1]) {
              this.selectedColorStones[currentGroup.Key - 1] = null
            }
          }

        }

        stoneGroupList.push({index: currentGroup.Key, stoneList: lStoneList})
      }

      return stoneGroupList
    },

  },
  watch: {
    'data.STNB.Value':{
      handler(newValue) {
        this.resetStoneEngravings()
      },
      deep: true,
    }
  },
  created() {
    const stoneKeys = Object.keys(this.product.FormData.CS)
    const length = stoneKeys.length
    for (let i = 0; i < length; i++) {
      if (this.StoneGroupList[i]) {
        const currentSelectedStone = this.StoneGroupList[i].stoneList.find(
          (stone) => {
            return stone.ID == this.product.FormData.CS[stoneKeys[i]].Value
          }
        )
        if (currentSelectedStone) {
          currentSelectedStone.selectedStone = true
          this.onStoneSelected(currentSelectedStone, i)
        }
      }
    }
  },
  methods: {
    customValueComparator(a, b) {
      return a.Value === b.Value
    },
    getImageSource(code, stoneType) {
      const lStoneImageUrl = `${this.apiRootUrl}stones/${stoneType}/`
      if (code) {
        if (!code.includes('DI') && code.includes('&')) {
          return `${lStoneImageUrl}${code.substr(0, code.indexOf('&'))}.png?v=${
            this.$config.contentVersion
          }`
        }
        return `${lStoneImageUrl}${code.includes('DI') ? 'DIA' : code}.png?v=${
          this.$config.contentVersion
        }`
      } else {
        return `${lStoneImageUrl}choose-a-stone.png`
      }
    },
    getHeaderText(code, StoneTypes, bold) {
      if (code && StoneTypes[code]) {
        return bold == true
          ? StoneTypes[code].split(' ')[0]
          : StoneTypes[code].replace(StoneTypes[code].split(' ')[0], '')
      }
      return bold == true ? '' : 'Choose a stone'
    },
    onColorStoneChange(value, key) {
      this.$emit('updateValue', {
        controlType: this.control.type,
        controlName: this.control.name,
        value,
      })
    },
    stoneHasEngraving(groupValue, key) {
      if (
        Object.keys(
          this.stonePositions.StoneNumber[groupValue].Position
        )[0].indexOf('_') > 0
      ) {
        key = key + '_1'
      }
      return (
        this.stonePositions.StoneNumber[groupValue] &&
        this.stonePositions.StoneNumber[groupValue].Position[key] &&
        this.stonePositions.StoneNumber[groupValue].Position[key].path_d !=
          undefined
      )
    },
    stoneHasTwoEngraving(groupValue, key) {
      if (
        Object.keys(
          this.stonePositions.StoneNumber[groupValue].Position
        )[0].indexOf('_') > 0
      ) {
        key = key + '_1'
      }
      return (
        this.stonePositions.StoneNumber[groupValue] &&
        this.stonePositions.StoneNumber[groupValue].Position[key] &&
        this.stonePositions.StoneNumber[groupValue].Position[key]
          .text_startOffset2 != undefined
      )
    },
    onEngravingTextChanged(event, groupValue, grouKey, key, isSecondText) {
      if (event) {
        // this.$parent.$refs.ImageViewer.$refs.previewDiv.style.zIndex = '-1'
        const fontCase =
          this.stonePositions.StoneNumber[grouKey] &&
          this.stonePositions.StoneNumber[grouKey].Position[key] &&
          this.stonePositions.StoneNumber[grouKey].Position[key].text_case
        const textFormatted =
          fontCase === 'lower'
            ? event.target.value.charAt(0).toUpperCase() +
              event.target.value.slice(1).toLowerCase()
            : event.target.value.toUpperCase()
        if (isSecondText === false) {
          this.$emit('updateValue', {
            controlType: this.control.type,
            controlName: this.control.name,
            controlSubName: groupValue,
            secondValue: textFormatted,
          })
        } else {
          this.$emit('updateValue', {
            controlType: this.control.type,
            controlName: this.control.name,
            controlSubName: groupValue,
            thirdValue: textFormatted,
          })
        }
      }
    },
    /* getEngravingText: function getEngravingText(stoneNumber) {
      return this.roduct.FormData.CS[groupValue].SecondValue;

    }, */
    getHeaderRefNumber(key) {
      return 'stone ' + key
    },
    getBodyRefNumber(key) {
      return 'groupBody' + key
    },
    EngravingToggleChanged(event, key) {
      // this.$parent.$refs.ImageViewer.$refs.previewDiv.style.zIndex = '-1'
      // TODO-IMPORTANT some bulk action must be implemented here, we are now firing the event for each possible colored stone
      for (const item in this.product.FormData.CS) {
        this.$emit('updateValue', {
          controlType: this.control.type,
          controlName: this.control.name,
          controlSubName: item,
          secondValue: null,
        })
        this.$emit('updateValue', {
          controlType: this.control.type,
          controlName: this.control.name,
          controlSubName: item,
          thirdValue: null,
        })
      }
      this.$emit('updateValue', {
        controlType: this.control.type,
        controlName: 'ENGRAVABLE',
        value: event.target.checked ? 1 : 0,
      })
    },
    getVisibleOptions(Options, position) {
      const lVisibleOptions = Options.constructor()
      let maObject = this.data["MA"];
      let maPropertyName = Object.keys(maObject)[0];
      let selectedMetal = maObject[maPropertyName]["Value"];
      for (const item in Options) {
        if (
          Options[item].Class == null ||
          Options[item].Class == this.currentStoneNumber ||
          Options[item].Class == selectedMetal
        ) {

          // Do not add Synthetic diamond variants to stone selector
          if (this.data.CST
              && this.data.CST.Value === 'SYN'
              && Options[item].value.indexOf('DI.') !== -1
          ) {
            continue;
          }
          if (this.stonePositions.LimitStone && this.stonePositions.LimitStone.find(x => Options[item].value.startsWith(x.Stone))){
            const limitation = this.stonePositions.LimitStone.find(x => Options[item].value.startsWith(x.Stone) && x.LimitToType == this.data.CST.Value )
            if (!limitation){
              continue;
            }

            //Checks if stone has limit to a stone number -> if it does and its not the current stone number the stone gets skipped
            if (limitation.LimitToStoneNumber && !limitation.LimitToStoneNumber[this.data.STNB.Value]){
              continue;
            }

            //Checks if stone has exclusion from a position within the stone number -> if it does the stone gets skipped
            if (limitation.LimitToStoneNumber && limitation.LimitToStoneNumber[this.data.STNB.Value]){
               const positionLimitation = limitation.LimitToStoneNumber[this.data.STNB.Value];

               if (positionLimitation.ExcludeFromPositions && positionLimitation.ExcludeFromPositions.includes(parseInt(position))){
                  continue;
               }
            }


          }


          lVisibleOptions.push(Options[item])
        }
      }
      return lVisibleOptions
    },
    onStoneSelected(currentStone, index) {

      if (currentStone) {
        this.selectedColorStones[index] = currentStone

        this.$emit('updateValue', {
          controlType: this.control.type,
          controlName: this.control.name,
          controlSubName: currentStone.GroupValue,
          value: currentStone.Value,
          summary: this.getSummary(currentStone),
        })
      }
    },
    getSummary(currentStone) {
      return currentStone.Value.includes('DI.')
        ? `${currentStone.shape} ${currentStone.Month}`
        : `${currentStone.shape} ${currentStone.Name.split('<')[0]}`
    },
    reorderStoneTypes(stonesLists) {
      let reorderedStonesList = []
      let reorderedSelectedStones = []

      for (var stonesList of stonesLists) {
        if (stonesList.StonesOrder) {
          const position = stonesList.StonesOrder[this.currentStoneNumber - 1]

          if (position) {
            reorderedStonesList[position - 1] = stonesList

            if (this.selectedColorStones.length) {
              const currentStone = this.selectedColorStones.find(x => x && x.GroupValue && x.GroupValue === stonesList.Value)

              if (currentStone) {
                reorderedSelectedStones[position - 1] = currentStone
              }
            }
          }
        }
        else {
          reorderedStonesList.push(stonesList)
        }
      }

      if (reorderedSelectedStones.length) {
        this.selectedColorStones = reorderedSelectedStones
      }

      return reorderedStonesList;
    },
    resetStoneEngravings(){
      if (this.product.FormData.CS){
        for (const stone in this.product.FormData.CS) {
          this.product.FormData.CS[stone].SecondValue = null
          this.product.FormData.CS[stone].ThirdValue = null
        }

      }
    },
    getMaximumCharacterLimit(currentStoneNumber, index){
      return this.stonePositions.StoneNumber[currentStoneNumber]?.Position[++index]?.character_limit ?? 9
    }
  },
}
